import { Fragment, useEffect, useState } from "react";
import "../FilePage/FilePage.css";
import SidePanel from "../../Components/SidePanel/SidePanel";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Paginations from "../../Components/Paginations/Paginations";
import { useNavigate } from "react-router-dom";
import FilePageService from "../../API/FilePage/FilePageService";
import { useTranslation } from "react-i18next";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import Loading from "../../Common/Loading";
import { BsPatchExclamation } from "react-icons/bs";
import AddProduct from "./AddProduct";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { MultiSelect } from "react-multi-select-component";
import Select from "react-select";
import DashboardManagementService from "../../API/DashboardManagement/DashboardManagementService";
import AddGuaranteeBasis from "../GuaranteeBasis/AddGuaranteeBasis";

const Products = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [isViewLoading, setIsViewLoading] = useState(false);
  const [productListData, setProductListData] = useState([]);
  const [riskTypeList, setRiskTypeList] = useState([]);
  const [qRBasisList, setQRBasisList] = useState([]);
  const [quotationBasisList, setQuotationBasisList] = useState([]);
  const [guaranteeBasisList, setGuaranteeBasisList] = useState([]);
  const [productStatus, setProductStatus] = useState("");
  const [riskTypeFilter, setRiskTypeFilter] = useState("");
  const [updateProductStatus, setUpdateProductStatus] = useState("");
  const [productId, setProductId] = useState("");
  const [productName, setProductName] = useState("");
  const [search, setSearch] = useState("");
  const [activeTab, setActiveTab] = useState("basicInformation");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [logoImageShow, setLogoImageShow] = useState("");
  const [rightPanelThemeColor, setRightPanelThemeColor] = useState("");
  const [isRotated, setIsRotated] = useState(false);
  const [deletePermission, setDeletePermission] = useState(false);
  const [sort, setSort] = useState({ key: "created_at", value: "desc" });
  const [flashMessage, setFlashMessage] = useState({ type: "", message: "" });
  const [insurerOptions, setInsurerOptions] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    assureur_ids: [],
    risk_type: "",
    description: "",
    qr_basis_ids: [],
    quotation_basis_ids: [],
    guarantee_basis_ids: [],
  });

  const [showmodal, setShowmodal] = useState(false);
  const handleModalShow = () => setShowmodal(true);
  const handleModalClose = () => {
    setSelectIsRequired("");
    setSelectGuaranteeId("");
    setShowmodal(false);
  };
  const [showFolderId, setShowFolderId] = useState("");

  const [showAddNoteModal, setShowAddNoteModal] = useState(false);
  const handleAddNoteModalOpen = () => setShowAddNoteModal(true);
  const handleAddNoteModalClose = () => setShowAddNoteModal(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  const [formShowAdd, setFormShowAdd] = useState(false);
  const handleFormShowAdd = () => setFormShowAdd(true);
  const handleFormCloseAdd = () => setFormShowAdd(false);

  const [showView, setShowView] = useState(false);
  const handleViewClose = () => {
    setShowView(false);
    setIsViewLoading(false);
    setProductId("");
    setActiveTab("basicInformation");
    setFormData({
      name: "",
      assureur_ids: [],
      risk_type: "",
      description: "",
      qr_basis_ids: [],
      quotation_basis_ids: [],
      guarantee_basis_ids: [],
    });
  };
  const handleViewShow = (id) => {
    setShowView(true);
    setIsViewLoading(true);
    setProductId(id);
    setActiveTab("basicInformation");
  };

  const [modalColumns, setModalColumns] = useState({
    Nom: true,
    "Type de risque": true,
    Description: true,
    status: true,
    "Créé par": true,
  });

  const [selectedColumns, setSelectedColumns] = useState(
    Object.keys(modalColumns).filter((key) => modalColumns[key])
  );

  const [selectIsRequired, setSelectIsRequired] = useState("");
  const [selectGuaranteeIsRequired, setSelectGuaranteeIsRequired] = useState("");
  const [selectGuaranteeId, setSelectGuaranteeId] = useState("");
  const [showNotRequiredStatusChange, setShowNotRequiredStatusChange] = useState(false);
  const handleNotRequiredChangeShow = () => setShowNotRequiredStatusChange(true);
  const handleNotRequiredChangeClose = () => setShowNotRequiredStatusChange(false);

  useEffect(() => {
    if (flashMessage.message) {
      const timer = setTimeout(() => {
        setFlashMessage({ type: "", message: "" });
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [flashMessage]);

  useEffect(() => {
    if (deletePermission) {
      setModalColumns((prev) => ({
        ...prev,
        Action: true,
      }));
      const newSelectedColumns = Object.keys(modalColumns).filter(
        (key) => modalColumns[key]
      );
      newSelectedColumns.push("Action");
      setSelectedColumns(newSelectedColumns);
    }
  }, [deletePermission]);

  useEffect(() => {
    const userRole = JSON.parse(localStorage.getItem("userRole"));
    const token = localStorage.getItem("authToken");
    const can_delete_folder = JSON.parse(
      localStorage.getItem("can_delete_folder")
    );
    setDeletePermission(can_delete_folder == 1 ? true : false);
    if (token && userRole.includes("Administrateur")) {
      const logo_image = JSON.parse(localStorage.getItem("logo_image"));
      const right_panel_color = JSON.parse(localStorage.getItem("right_panel_color"));
      setRightPanelThemeColor(right_panel_color);
      setLogoImageShow(logo_image);
      ProductList(search, sort, currentPage, productStatus, riskTypeFilter);
    } else {
      navigate("/");
    }
  }, [sort]);

  useEffect(() => {
    RiskTypeList();
    GetInsurersList();
    QRBasisList();
    QuotationBasisList();
    GuaranteeBasisList();
  }, []);

  useEffect(() => {
    if (showView && productId) {
      ViewProduct(productId);
    }
  }, [showView, productId, activeTab]);

  const GetInsurersList = async () => {
    try {

      const response = await DashboardManagementService.insurer_list();

      if (response.data) {
        const insurerList = response.data.insurerList || [];
        const insurerOptions = insurerList.map((data) => ({ value: data.id, label: data.first_name }));
        setInsurerOptions(insurerOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const RiskTypeList = async () => {
    try {
      const response = await FilePageService.risk_types_list();

      if (response.data.status) {
        setRiskTypeList(response.data.risk_types);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const QRBasisList = async () => {
    try {
      const response = await FilePageService.admin_qr_basis_list();

      if (response.data.status) {
        setQRBasisList(response.data.basisList);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const QuotationBasisList = async () => {
    try {
      const response = await FilePageService.quotation_basis_list();

      if (response.data.status) {
        setQuotationBasisList(response.data.quotationBasisList);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const GuaranteeBasisList = async () => {
    try {
      const response = await FilePageService.guarantee_basis_list();

      if (response.data.status) {
        setGuaranteeBasisList(response.data.guaranteeBasisList);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const ViewProduct = async (productId, selectIsRequired) => {
    setIsViewLoading(true);
    try {

      var userData = {
        is_required: selectIsRequired || ""
      }

      const response = await FilePageService.product_show(productId, userData);

      if (response.data.status) {
        setIsViewLoading(false);
        const details = response.data.insurerProduct;

        if (showView) {
          const selectedRiskType = riskTypeOptions.find(
            (option) => option.value.toString() === details.risk_type?.toString()
          );

          setFormData({
            name: details?.name || "",
            risk_type: selectedRiskType?.value || "",
            description: details?.description || "",

            assureur_ids: details?.assureur_ids
              ? Object.values(details.assureur_ids).map((item) => ({
                value: item.id,
                label: item.name,
              }))
              : [],

            qr_basis_ids: details?.qr_basis_ids
              ? Object.values(details.qr_basis_ids).map((item) => ({
                value: item.id,
                label: item.name,
              }))
              : [],

            quotation_basis_ids: details?.quotation_basis_ids
              ? Object.values(details.quotation_basis_ids).map((item) => ({
                value: item.id,
                label: item.name,
              }))
              : [],

            guarantee_basis_ids: details?.guarantee_basis_ids
              ? Object.values(details.guarantee_basis_ids).map((item) => ({
                value: item.guarantee_basis_id,
                value_id: item.id,
                label: item.name,
                description: item.description,
                is_required: item.is_required
              }))
              : [],
          });
        }
      }
      setIsViewLoading(false);
    } catch (error) {
      setIsViewLoading(false);
      console.error("Error fetching product:", error);
    }
  };

  const ProductList = async (search, sort, page = 1, status, riskType) => {
    setIsLoading(true);
    try {
      var userData = {
        search: search,
        sort: {
          key: sort.key,
          value: sort.value,
        },
        status: status,
        risk_type: riskType,
        page,
      };
      const response = await FilePageService.product_index(userData);
      if (response.data.status) {
        setIsLoading(false);
        setProductListData(response.data.insurer_products.data);
        setCurrentPage(response.data.insurer_products.meta.current_page);
        setTotalPages(response.data.insurer_products.meta.last_page);
        setTotalRecords(response.data.insurer_products.meta.total);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const HandleDeleteDocumentFile = async () => {
    try {
      const response = await FilePageService.product_destroy(
        showFolderId
      );
      if (response.data.status) {
        handleCloseDeleteModal();
        setShowFolderId("");
        ProductList(search, sort, currentPage, "", "");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const HandleUpdateStatus = async () => {
    try {
      var useData = {
        status: updateProductStatus == 1 ? "0" : "1",
      };
      const response = await FilePageService.product_update_status(
        productId,
        useData
      );
      if (response.data.status) {
        setProductStatus("");
        ProductList(search, sort, currentPage, "", "");
        handleModalClose();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const HandleRequiredOrNot = async () => {
    try {
      var useData = {
        is_required: selectGuaranteeIsRequired == '1' ? '0' : '1',
      };
      const response = await FilePageService.guarantee_basis_required_status_update(selectGuaranteeId, useData);
      if (response.data.status) {
        ViewProduct(productId);
        handleNotRequiredChangeClose();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSearchChange = (search) => {
    setSearch(search);
    ProductList(search, sort, 1, productStatus, riskTypeFilter);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearchChange(search);
    }
  };

  const HandleFilterStatus = (status) => {
    setProductStatus(status);
    ProductList(search, sort, 1, status, riskTypeFilter);
  };

  const HandleRiskTypeFilter = (risk_type) => {
    setRiskTypeFilter(risk_type);
    ProductList(search, sort, 1, productStatus, risk_type);
  };

  const handleStatusChange = (id, status) => {
    setProductId(id);
    setUpdateProductStatus(status);
    handleModalShow();
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    ProductList(search, sort, page, productStatus, riskTypeFilter);
  };

  const handleClickRotate = (column) => {
    const direction =
      sort.key === column ? (sort.value === "desc" ? "asc" : "desc") : "asc";
    setSort({ key: column, value: direction });
    setIsRotated(!isRotated);
  };

  const handleAddNoteModalCloseAfterAPICall = () => {
    setShowAddNoteModal(false);
    ProductList(search, sort, currentPage, productStatus, riskTypeFilter);
  };

  const riskTypeOptions = Object.entries(riskTypeList).map(([key, label]) => ({
    value: key,
    label: label,
  }));

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
  };

  const handleQRBasisChange = (selected) => {
    setFormData((prev) => ({
      ...prev,
      qr_basis_ids: selected,
    }));
  };

  const handleQuotationBasisChange = (selected) => {
    setFormData((prev) => ({
      ...prev,
      quotation_basis_ids: selected,
    }));
  };

  const handleGuaranteeBasisChange = (selected) => {
    setFormData((prev) => ({
      ...prev,
      guarantee_basis_ids: selected,
    }));
  };

  const handleAssureurAssignChange = (selected) => {
    setFormData((prev) => ({
      ...prev,
      assureur_ids: selected,
    }));
  };

  const QRBasisOptions =
    qRBasisList?.map((item) => ({
      label: item.name,
      value: item.id,
    })) || [];

  const QuotationBasisOptions =
    quotationBasisList?.map((item) => ({
      label: item.name,
      value: item.id,
    })) || [];

  const GuaranteeBasisOptions =
    guaranteeBasisList?.map((item) => ({
      label: item.name,
      value: item.id,
    })) || [];

  const handleChange = (e) => {
    const { name, value, type, max } = e.target;
    let val = value;

    if (type === "number") {
      const numericValue = Number(value);
      const maxValue = max ? Number(max) : Infinity;
      val = Math.max(0, Math.min(maxValue, numericValue));
    }

    setFormData((prev) => ({
      ...prev,
      [name]: val,
    }));
  };

  const ViewProductUpdate = async (e) => {
    e.preventDefault();
    if (isLoading) return;

    const {
      name,
      assureur_ids,
      risk_type,
      description,
      qr_basis_ids,
      quotation_basis_ids,
      guarantee_basis_ids,
    } = formData;

    if (
      !name ||
      !risk_type ||
      guarantee_basis_ids.length === 0
    ) {
      setFlashMessage({
        type: "error",
        message: t("requriedErrorMessageLabel"),
      });
      return;
    }

    setIsLoading(true);

    const payload = {
      name: name,
      ...(assureur_ids?.length > 0 && { assureur_ids: assureur_ids.map((q) => q.value) }),
      risk_type: risk_type,
      ...(description && { description: description }),
      ...(qr_basis_ids?.length > 0 && { qr_basis_ids: qr_basis_ids.map((q) => q.value) }),
      ...(quotation_basis_ids?.length > 0 && { quotation_basis_ids: quotation_basis_ids.map((q) => q.value) }),
      guarantee_basis_ids: guarantee_basis_ids.map((q) => q.value),
    };

    try {
      const response = await FilePageService.product_update(productId, payload);

      if (response.data.status) {
        setIsLoading(false);
        handleAddNoteModalCloseAfterAPICall();
        setFlashMessage({
          type: "success",
          message: response.data.message || t("somethingWentWrong"),
        });
      } else {
        setIsLoading(false);
        setFlashMessage({
          type: "error",
          message: response.data.message || t("somethingWentWrong"),
        });
      }
    } catch (error) {
      setIsLoading(false);
      setFlashMessage({
        type: "error",
        message: error.response?.data?.message || t("somethingWentWrong"),
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleTableIsRequiredChange = (e) => {
    const selectedValue = e.target.value;
    setSelectIsRequired(selectedValue);
    ViewProduct(productId, selectedValue);
  };

  return (
    <Fragment>
      <style>
        {" "}
        {` button.btn.btn-primary  { background-color: ${localStorage.getItem("button_color")
          ? JSON.parse(localStorage.getItem("button_color"))
          : "#e84455"
          } !Important};`}{" "}
      </style>

      <SidePanel
        sidebarLogo={
          (logoImageShow != "" ||
            logoImageShow != null ||
            logoImageShow != undefined) &&
          `${process.env.REACT_APP_IMAGE_URL}/${logoImageShow}`
        }
      />

      {(!isViewLoading && !showView) ?
        <div
          className="dashboard-main-content user-dashboard"
          style={{ backgroundColor: rightPanelThemeColor }}
        >
          <div className="top-header">
            <div className="mt-3 d-md-flex justify-content-between align-items-center">
              <h1 className="m-md-0 mb-3">Liste des produits</h1>
            </div>
          </div>
          <div className="table-wrapper mt-24">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <Form.Group
                className="relative"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Control
                  type="search"
                  placeholder="Rechercher"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onKeyDown={handleKeyPress}
                />
                <div
                  className="search-icon"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSearchChange(search)}
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.7549 11.2549H11.9649L11.6849 10.9849C12.6649 9.84488 13.2549 8.36488 13.2549 6.75488C13.2549 3.16488 10.3449 0.254883 6.75488 0.254883C3.16488 0.254883 0.254883 3.16488 0.254883 6.75488C0.254883 10.3449 3.16488 13.2549 6.75488 13.2549C8.36488 13.2549 9.84488 12.6649 10.9849 11.6849L11.2549 11.9649V12.7549L16.2549 17.7449L17.7449 16.2549L12.7549 11.2549ZM6.75488 11.2549C4.26488 11.2549 2.25488 9.24488 2.25488 6.75488C2.25488 4.26488 4.26488 2.25488 6.75488 2.25488C9.24488 2.25488 11.2549 4.26488 11.2549 6.75488C11.2549 9.24488 9.24488 11.2549 6.75488 11.2549Z"
                      fill="#998f90"
                    />
                  </svg>
                </div>
              </Form.Group>
              <button
                onClick={handleAddNoteModalOpen}
                className="btn btn-primary"
              >
                Ajouter un produit
              </button>
              <AddProduct
                showmodal={showAddNoteModal}
                handleModalClose={handleAddNoteModalClose}
                handleAddNoteModalCloseAfterAPICall={
                  handleAddNoteModalCloseAfterAPICall
                }
                riskTypeList={riskTypeList}
              />
            </div>

            {isLoading ? (
              <Loading />
            ) : (
              <div className="table-wrap mt-24">
                <Table responsive hover>
                  <thead>
                    <tr>
                      {selectedColumns.includes("Nom") && (
                        <th>
                          <div className="d-flex align-items-center">
                            <span>Nom</span>
                            <Link
                              className={`sorting-icon ms-2`}
                              onClick={() => handleClickRotate("name")}
                            >
                              {sort.value === "asc" && (
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                    fill="black"
                                  />
                                  <path
                                    d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                    fill="black"
                                    fillOpacity="0.5"
                                  />
                                </svg>
                              )}

                              {sort.value === "desc" && (
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                    fill="black"
                                    fillOpacity="0.5"
                                  />
                                  <path
                                    d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                    fill="black"
                                  />
                                </svg>
                              )}
                            </Link>
                          </div>
                        </th>
                      )}
                      {selectedColumns.includes("Type de risque") && (
                        <th>
                          <div className="d-flex align-items-center">
                            <div>
                              <Form.Select
                                aria-label="statusSelectAria"
                                value={riskTypeFilter}
                                onChange={(e) =>
                                  HandleRiskTypeFilter(e.target.value)
                                }
                              >
                                <option value="">{t("Type de risque")}</option>
                                {riskTypeOptions?.map((data, index) => (
                                  <option key={index} value={data.value}>
                                    {data.label}
                                  </option>
                                ))}
                              </Form.Select>
                            </div>
                            <Link
                              className={`sorting-icon ms-2`}
                              onClick={() => handleClickRotate("risk_type")}
                            >
                              {sort.value === "asc" && (
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                    fill="black"
                                  />
                                  <path
                                    d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                    fill="black"
                                    fillOpacity="0.5"
                                  />
                                </svg>
                              )}

                              {sort.value === "desc" && (
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                    fill="black"
                                    fillOpacity="0.5"
                                  />
                                  <path
                                    d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                    fill="black"
                                  />
                                </svg>
                              )}
                            </Link>
                          </div>
                        </th>
                      )}
                      {selectedColumns.includes("Description") && (
                        <th>
                          <div className="d-flex align-items-center">
                            <span>{t("Description")}</span>
                            <Link
                              className={`sorting-icon ms-2`}
                              onClick={() => handleClickRotate("description")}
                            >
                              {sort.value === "asc" && (
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                    fill="black"
                                  />
                                  <path
                                    d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                    fill="black"
                                    fillOpacity="0.5"
                                  />
                                </svg>
                              )}

                              {sort.value === "desc" && (
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                    fill="black"
                                    fillOpacity="0.5"
                                  />
                                  <path
                                    d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                    fill="black"
                                  />
                                </svg>
                              )}
                            </Link>
                          </div>
                        </th>
                      )}
                      {selectedColumns.includes("status") && (
                        <th className="select-drop">
                          <div className="d-flex align-items-center">
                            <div>
                              <Form.Select
                                aria-label="statusSelectAria"
                                value={productStatus}
                                onChange={(e) =>
                                  HandleFilterStatus(e.target.value)
                                }
                              >
                                <option value="">{t("status")}</option>
                                <option value={0}>{t("inActiveLabel")}</option>
                                <option value={1}>{t("activeLabel")}</option>
                              </Form.Select>
                            </div>
                            <div>
                              <Link
                                className={`sorting-icon ms-2`}
                                onClick={() => handleClickRotate("status")}
                              >
                                {sort.value === "asc" && (
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                      fill="black"
                                    />
                                    <path
                                      d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                      fill="black"
                                      fillOpacity="0.5"
                                    />
                                  </svg>
                                )}

                                {sort.value === "desc" && (
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                      fill="black"
                                      fillOpacity="0.5"
                                    />
                                    <path
                                      d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                      fill="black"
                                    />
                                  </svg>
                                )}
                              </Link>
                            </div>
                          </div>
                        </th>
                      )}
                      {selectedColumns.includes("Créé par") && (
                        <th>
                          <div className="d-flex align-items-center">
                            <span>{t("Créé par")}</span>
                            <Link
                              className={`sorting-icon ms-2`}
                              onClick={() => handleClickRotate("created_by")}
                            >
                              {sort.value === "asc" && (
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                    fill="black"
                                  />
                                  <path
                                    d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                    fill="black"
                                    fillOpacity="0.5"
                                  />
                                </svg>
                              )}

                              {sort.value === "desc" && (
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M9 3L5 6.99H8V14H10V6.99H13L9 3ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
                                    fill="black"
                                    fillOpacity="0.5"
                                  />
                                  <path
                                    d="M16 10V17.01H19L15 21L11 17.01H14V10H16Z"
                                    fill="black"
                                  />
                                </svg>
                              )}
                            </Link>
                          </div>
                        </th>
                      )}
                      {selectedColumns.includes("Action") && deletePermission && (
                        <th>Action</th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {productListData?.length > 0 &&
                      selectedColumns?.length > 0 ? (
                      productListData.map((data, index) => (
                        <tr key={index}>
                          {selectedColumns.includes("Nom") && (
                            <td className="bold-font">
                              <div style={{ lineHeight: 1 }}>
                                {data.is_important == 1 && (
                                  <BsPatchExclamation
                                    style={{
                                      color: "red",
                                      fontSize: "1.0rem",
                                      cursor: "pointer",
                                    }}
                                    title="Nom"
                                  />
                                )}
                                <div style={{ marginTop: "4px" }}>
                                  {data?.name}
                                </div>
                              </div>
                            </td>
                          )}
                          {selectedColumns.includes("Type de risque") && (
                            <td>{data?.risk_name}</td>
                          )}
                          {selectedColumns.includes("Description") && (
                            <td className="bold-font">{data?.description}</td>
                          )}
                          {selectedColumns.includes("status") && (
                            <td>
                              {data.status == 1 ? (
                                <span
                                  className="verified badges"
                                  onClick={() =>
                                    handleStatusChange(data.id, data.status)
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  {t("activeLabel")}
                                </span>
                              ) : (
                                <span
                                  className="incomplete badges"
                                  onClick={() =>
                                    handleStatusChange(data.id, data.status)
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  {t("inActiveLabel")}
                                </span>
                              )}
                            </td>
                          )}
                          {selectedColumns.includes("Créé par") && (
                            <td>
                              {data.created_by &&
                                `${data.created_by.first_name} ${data.created_by.last_name}`}
                            </td>
                          )}
                          {selectedColumns.includes("Action") &&
                            deletePermission && (
                              <td>
                                <div className="action-btn">
                                  <Link
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setProductName(data.name);
                                      handleViewShow(data.id);
                                    }}
                                    className="view"
                                    href="/user-management"
                                    data-discover="true"
                                    title="Voir"
                                  >
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M12 6.5C15.79 6.5 19.17 8.63 20.82 12C19.17 15.37 15.8 17.5 12 17.5C8.2 17.5 4.83 15.37 3.18 12C4.83 8.63 8.21 6.5 12 6.5ZM12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 9.5C13.38 9.5 14.5 10.62 14.5 12C14.5 13.38 13.38 14.5 12 14.5C10.62 14.5 9.5 13.38 9.5 12C9.5 10.62 10.62 9.5 12 9.5ZM12 7.5C9.52 7.5 7.5 9.52 7.5 12C7.5 14.48 9.52 16.5 12 16.5C14.48 16.5 16.5 14.48 16.5 12C16.5 9.52 14.48 7.5 12 7.5Z"
                                        fill="#00366B"
                                      />
                                    </svg>
                                  </Link>
                                  <Link
                                    className="delete"
                                    href="/user-management"
                                    data-discover="true"
                                    title="Supprimer"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleShowDeleteModal();
                                      setShowFolderId(data.id);
                                    }}
                                  >
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z"
                                        fill="#00366B"
                                      />
                                    </svg>
                                  </Link>
                                </div>
                              </td>
                            )}
                        </tr>
                      ))
                    ) : (
                      <tr style={{ textAlign: "center" }}>
                        <td colSpan="11">{t("NorecordsfoundLabel")}</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            )}
            {totalRecords > 10 && (
              <Paginations
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                itemsPerPage={10}
                totalItems={totalRecords}
              />
            )}
          </div>
        </div>
        :
        <div
          className="dashboard-main-content user-management"
          style={{ backgroundColor: rightPanelThemeColor }}
        >
          <h1 className="mb-5">{`Vue du produit - ${productName}`}</h1>
          <div className="d-block mb-4">
            <span className="back-screen" onClick={handleViewClose}>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="23" viewBox="0 0 18 23" fill="none">
                <path
                  d="M17.4148 11.8702C17.0398 11.4952 16.5311 11.2846 16.0008 11.2846C15.4705 11.2846 14.9619 11.4952 14.5868 11.8702L11.0008 15.4562V2.28418C11.0008 1.75375 10.7901 1.24504 10.415 0.869966C10.04 0.494893 9.53125 0.28418 9.00081 0.28418C8.47038 0.28418 7.96167 0.494893 7.5866 0.869966C7.21153 1.24504 7.00081 1.75375 7.00081 2.28418V15.4562L3.41481 11.8702C3.03761 11.5059 2.53241 11.3043 2.00801 11.3088C1.48362 11.3134 0.981993 11.5237 0.611177 11.8945C0.240361 12.2654 0.0300231 12.767 0.0254662 13.2914C0.0209094 13.8158 0.222498 14.321 0.586814 14.6982L7.58681 21.6982C7.96187 22.0731 8.47049 22.2838 9.00081 22.2838C9.53114 22.2838 10.0398 22.0731 10.4148 21.6982L17.4148 14.6982C17.7898 14.3231 18.0004 13.8145 18.0004 13.2842C18.0004 12.7539 17.7898 12.2452 17.4148 11.8702Z"
                  fill="#00366B"
                />
              </svg>
            </span>
          </div>

          <Tabs
            defaultActiveKey="broker"
            id="uncontrolled-tab-example"
            activeKey={activeTab}
            onSelect={handleTabChange}
            className=""
          >

            {/* Information Tab */}
            <Tab eventKey="basicInformation" title="Informations de base">
              {isViewLoading ? (
                <Loading />
              ) : (
                <Form className="mt-24" onSubmit={ViewProductUpdate}>
                  {flashMessage.message && (
                    <div
                      className={`mt-3 mx-w-320 alert ${flashMessage.type === "success"
                        ? "alert-success"
                        : "alert-danger"
                        } text-center`}
                      role="alert"
                    >
                      {flashMessage.message}
                    </div>
                  )}
                  <div className="mt-3">
                    <Form.Group
                      className="mb-4"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>
                        Nom du produit <span>*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Nom du produit"
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Assureur assigné</Form.Label>
                      <MultiSelect
                        options={insurerOptions}
                        value={formData.assureur_ids}
                        onChange={handleAssureurAssignChange}
                        labelledBy="Sélectionnez Assureur"
                        overrideStrings={{
                          selectSomeItems: "Sélectionnez Assureur",
                          allItemsAreSelected:
                            "Toutes les options sont sélectionnées",
                          selectAll: "Tout sélectionner",
                          search: "Recherche",
                        }}
                      />
                    </Form.Group>

                    <Form.Group
                      className="mb-4"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>
                        Type de risque <span>*</span>
                      </Form.Label>
                      <Select
                        options={riskTypeOptions}
                        value={riskTypeOptions.find(
                          (option) => option.value === formData.risk_type
                        )}
                        onChange={(selectedOption) =>
                          setFormData((prev) => ({
                            ...prev,
                            risk_type: selectedOption.value,
                          }))
                        }
                        styles={{
                          container: (provided) => ({
                            ...provided,
                            width: "100%",
                          }),
                          menu: (provided) => ({
                            ...provided,
                            width: "100%",
                          }),
                        }}
                        placeholder={"Sélectionnez le type de risque"}
                        isSearchable={true}
                        noOptionsMessage={() => t("NorecordsfoundLabel")}
                      />
                    </Form.Group>

                    <Form.Group
                      className="mb-4"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Base QR</Form.Label>
                      <MultiSelect
                        options={QRBasisOptions}
                        value={formData.qr_basis_ids}
                        onChange={handleQRBasisChange}
                        labelledBy="Select QR Basis"
                        overrideStrings={{
                          selectSomeItems: "Sélectionnez la base QR",
                          allItemsAreSelected:
                            "Toutes les options sont sélectionnées",
                          selectAll: "Tout sélectionner",
                          search: "Recherche",
                        }}
                      />
                    </Form.Group>

                    <Form.Group
                      className="mb-4"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Base de devis</Form.Label>
                      <MultiSelect
                        options={QuotationBasisOptions}
                        value={formData.quotation_basis_ids}
                        onChange={handleQuotationBasisChange}
                        labelledBy="Select Quotation Basis"
                        overrideStrings={{
                          selectSomeItems: "Sélectionner la base du devis",
                          allItemsAreSelected:
                            "Toutes les options sont sélectionnées",
                          selectAll: "Tout sélectionner",
                          search: "Recherche",
                        }}
                      />
                    </Form.Group>

                    <Form.Group
                      className="mb-4"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>
                        Base de garantie <span>*</span>
                      </Form.Label>
                      <MultiSelect
                        options={GuaranteeBasisOptions}
                        value={formData.guarantee_basis_ids}
                        onChange={handleGuaranteeBasisChange}
                        labelledBy="Select Guarantee Basis"
                        overrideStrings={{
                          selectSomeItems: "Sélectionnez la base de garantie",
                          allItemsAreSelected:
                            "Toutes les options sont sélectionnées",
                          selectAll: "Tout sélectionner",
                          search: "Recherche",
                        }}
                      />
                    </Form.Group>

                    <Form.Group
                      className="mb-4"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Description</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={2}
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        placeholder="Tapez ici..."
                      />
                    </Form.Group>
                  </div>
                  <Button
                    className="btn-secondary"
                    type="submit"
                  >
                    Valider
                  </Button>
                </Form>
              )}
            </Tab>

            {/* Guarantee Basis */}
            <Tab eventKey="GuaranteeBasis" title="Base de garantie">
              {isViewLoading ? (
                <Loading />
              ) : (
                <div className="table-wrap">
                  {activeTab == "GuaranteeBasis" && (
                    <div className="text-end mb-3">
                      <Button
                        onClick={() => handleFormShowAdd()}
                        variant="primary"
                      >
                        Ajouter une base de garantie
                      </Button>
                    </div>
                  )}
                  <Table responsive hover>
                    <thead>
                      <tr>
                        <th>{t("Nom")}</th>
                        <th>
                          <div className="d-flex align-items-center">
                            <div>
                              <Form.Select
                                aria-label="statusSelectAria"
                                value={selectIsRequired}
                                onChange={handleTableIsRequiredChange}
                              >
                                <option value="">Tout</option>
                                <option value="0">Non requis</option>
                                <option value="1">Requis</option>
                              </Form.Select>
                            </div>
                          </div>
                        </th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      {formData?.guarantee_basis_ids?.length > 0 ? (
                        formData?.guarantee_basis_ids?.map((data, index) => (
                          <tr key={index}>
                            <td className="bold-font">{data.label}</td>
                            <td>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={data.is_required == 1}
                                onChange={() => {
                                  handleNotRequiredChangeShow();
                                  setSelectGuaranteeId(data.value_id);
                                  setSelectGuaranteeIsRequired(data.is_required);
                                }}
                              />
                            </td>
                            <td>{data.description}</td>
                          </tr>
                        ))
                      ) : (
                        <tr style={{ textAlign: "center" }}>
                          <td colSpan="5">{t("NorecordsfoundLabel")}</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              )}
            </Tab>

            {/* Quotation Basis */}
            <Tab eventKey="QuotationBasis" title="Base de devis">
              {isViewLoading ? (
                <Loading />
              ) : (
                <div className="table-wrap mt-24">
                  <Table responsive hover>
                    <thead>
                      <tr>
                        <th>
                          {t("Nom")}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {quotationBasisList?.length > 0 ? (
                        quotationBasisList?.map((data, index) => (
                          <tr key={index}>
                            <td className="bold-font">
                              {data.name}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr style={{ textAlign: "center" }}>
                          <td colSpan="5">{t("NorecordsfoundLabel")}</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              )}
            </Tab>

            {/* QR Basis */}
            <Tab eventKey="QRBasis" title="Base QR">
              {isViewLoading ? (
                <Loading />
              ) : (
                <div className="table-wrap mt-24">
                  <Table responsive hover>
                    <thead>
                      <tr>
                        <th>
                          {t("Nom")}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {qRBasisList?.length > 0 ? (
                        qRBasisList?.map((data, index) => (
                          <tr key={index}>
                            <td className="bold-font">
                              {data.name}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr style={{ textAlign: "center" }}>
                          <td colSpan="5">{t("NorecordsfoundLabel")}</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              )}
            </Tab>
          </Tabs>
        </div>
      }

      {/* Add Guarantee Basis  */}
      <AddGuaranteeBasis
        show={formShowAdd}
        onHide={handleFormCloseAdd}
        search={search}
        sort={sort}
        GuaranteeBasisList={GuaranteeBasisList}
        productId={productId}
        ViewProduct={ViewProduct}
      />

      {/* Delete Confirmation Popup */}
      <Modal
        className="final-modal"
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h2>Confirmation</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Êtes-vous sûr de vouloir supprimer le produit de l'assureur ?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="cancel-btn"
            variant="primary"
            onClick={handleCloseDeleteModal}
          >
            {t("cancelLabel")}
          </Button>
          <Button variant="primary" onClick={HandleDeleteDocumentFile}>
            {t("confirmbtnLabel")}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Confirmation Popup */}
      <Modal
        className="missing-doc-modal"
        show={showmodal}
        onHide={() => setShowmodal(true)}
      >
        <Modal.Header closeButton onHide={handleModalClose}>
          <Modal.Title>
            <h2>{t("confirmStatusTitle")}</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span className="complete-process">{t("confirmStatusMessage")}</span>
        </Modal.Body>
        <Modal.Footer>
          <div className="text-end">
            <Button variant="primary" onClick={() => HandleUpdateStatus()}>
              {t("confirmbtnLabel")}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Requried & Not Requried Change Confirmation Popup */}
      <Modal
        className="missing-doc-modal"
        show={showNotRequiredStatusChange}
        onHide={() => setShowNotRequiredStatusChange(true)}
      >
        <Modal.Header closeButton onHide={handleNotRequiredChangeClose}>
          <Modal.Title>
            <h2>Confirmer</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span className="complete-process">
            Êtes-vous sûr de vouloir modifier le base de garantie requis ?
          </span>
        </Modal.Body>
        <Modal.Footer>
          <div className="text-end">
            <Button
              variant="primary"
              onClick={() => HandleRequiredOrNot()}
            >
              {t("confirmbtnLabel")}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default Products;